import { styled } from '@mui/material';

type SpacingProps = {
  pt?: number | string;
  pb?: number | string;
  pl?: number | string;
  pr?: number | string;
  mt?: number | string;
  mb?: number | string;
  ml?: number | string;
  mr?: number | string;
};

type TitleProps = SpacingProps & {
  color?: string;
  textAlign?: 'left' | 'center' | 'right' | 'justify' | 'inherit';
};

const getSpacingStyles = (props: SpacingProps) => ({
  paddingTop: props.pt,
  paddingBottom: props.pb,
  paddingLeft: props.pl,
  paddingRight: props.pr,
  marginTop: props.mt,
  marginBottom: props.mb,
  marginLeft: props.ml,
  marginRight: props.mr,
});

const createTitle = (tag: keyof JSX.IntrinsicElements, fontSize: string, fontWeight: number) =>
  styled(tag)<TitleProps>(({ color, textAlign, ...spacingProps }) => ({
    fontSize,
    fontWeight,
    margin: 0,
    color,
    textAlign,
    ...getSpacingStyles(spacingProps),
  }));

export const StyledTitleH1 = createTitle('h1', '46px', 700);
export const StyledTitleH2 = createTitle('h2', '38px', 700);
export const StyledTitleH3 = createTitle('h3', '22px', 600);
export const StyledTitleH4 = createTitle('h4', '18px', 600);
export const StyledTitleSubheader = createTitle('h5', '16px', 500);
